var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconRecyclingMenu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.666748 16.5001C0.666748 14.0001 2.20841 12.0334 4.90008 11.5001C6.91675 11.1001 9.00008 9.83341 9.83341 9.00008M8.16675 15.6667C6.70346 15.6712 5.29196 15.1255 4.21218 14.1379C3.1324 13.1504 2.46322 11.793 2.33736 10.3352C2.2115 8.8773 2.63816 7.42538 3.53271 6.26737C4.42725 5.10935 5.72436 4.32983 7.16675 4.08341C11.9167 3.16675 13.1667 2.73341 14.8334 0.666748C15.6667 2.33341 16.5001 4.15008 16.5001 7.33341C16.5001 11.9167 12.5167 15.6667 8.16675 15.6667Z",
    stroke: "#1A1D20",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRecyclingMenu);
export default __webpack_public_path__ + "static/media/icon-recycling-menu.91eb1d9b10250268737ce0bfbdd53f64.svg";
export { ForwardRef as ReactComponent };